import { Badge, Label, Offcanvas, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import Flatpickr from "react-flatpickr";
import Select from "react-select";

import React from "react";
import { handleDateFormat } from "../Common/HandleDateTime";
import "./Filter.styles.css";

import { openDateRangePicker } from "../Common/openDateRangePicker";
// Generic "is this filter currently doing something?" — works for any filter
// type so the panel scales as new filters are added.
function isFilterActive(item) {
  const v = item?.filterValue || {};
  switch (item?.filterType) {
    case "Select":
      return Boolean(v.Id);
    case "SelectMultiple":
      return (v.selectedItems?.length || 0) > 0;
    case "DateRange":
    case "DateRange2Values":
      return Boolean(v.startDate && v.endDate);
    case "NumberRange":
      return Boolean(v.min || v.max);
    case "Toggle":
      return v.on === true;
    default:
      return false;
  }
}

// Empty value for a given filter type — keeps per-filter clearing generic.
function emptyValueFor(item) {
  switch (item?.filterType) {
    case "Select":
      return { Id: "" };
    case "SelectMultiple":
      return { selectedItems: [] };
    case "DateRange":
    case "DateRange2Values":
      return { startDate: "", endDate: "" };
    case "NumberRange":
      return { min: "", max: "" };
    case "Toggle":
      return { on: false };
    default:
      return item?.filterValue;
  }
}

export default function Filter({
  showFilter,
  setShowFilter,
  toggleShowFilter,

  allowedFiltersInit,
  allowedFilters,
  setAllowedFilters,
}) {
  const activeFilters = (allowedFilters || []).filter(
    (f) => f.useThisFilter && isFilterActive(f)
  );
  const activeCount = activeFilters.length;

  const clearFilterAt = (index) => {
    setAllowedFilters((prev) =>
      prev.map((item, i) =>
        i === index ? { ...item, filterValue: emptyValueFor(item) } : item
      )
    );
  };

  return (
    <>
      <Offcanvas
        direction="end"
        isOpen={showFilter}
        id="offcanvasExample"
        toggle={toggleShowFilter}
        className="filter-offcanvas"
      >
        <OffcanvasHeader className="bg-light" toggle={toggleShowFilter}>
          <span className="d-flex align-items-center gap-2">
            <i className="ri-filter-3-line"></i>
            Filters
            {activeCount > 0 && (
              <Badge color="primary" pill className="fs-11">
                {activeCount}
              </Badge>
            )}
          </span>
        </OffcanvasHeader>
        <form className="d-flex flex-column justify-content-between h-100">
          <OffcanvasBody className="filter-body py-2">
            {allowedFilters?.map((item, index) =>
              item.useThisFilter ? (
                <div key={index} className="filter-section">
                  <div className="d-flex align-items-center justify-content-between mb-1">
                    <Label className="filter-section-label mb-0">
                      {item.filterTitle}
                    </Label>
                    {isFilterActive(item) && (
                      <button
                        type="button"
                        className="filter-section-clear"
                        onClick={() => clearFilterAt(index)}
                      >
                        <i className="ri-close-line"></i> Clear
                      </button>
                    )}
                  </div>

                  {item.filterType === "DateRange" && (
                    <div className="input-group input-group2">
                      <div></div>
                      <Flatpickr
                        className="form-control border-0 dash-filter-picker shadow"
                        options={{
                          mode: "range",
                          dateFormat: "d M Y",
                          altDateFormat: "Y-m-d",
                          defaultDate: [
                            item.filterValue.startDate &&
                              new Date(item.filterValue.startDate),
                            item.filterValue.endDate &&
                              new Date(item.filterValue.endDate),
                          ],
                        }}
                        onChange={(e) => {
                          let startDate = handleDateFormat(e[0]);
                          let endDate = handleDateFormat(e[1]);

                          setAllowedFilters((prevState) => {
                            const newState = [...prevState];
                            newState[index].filterValue.startDate = startDate;
                            newState[index].filterValue.endDate = endDate;
                            return newState;
                          });
                        }}
                        value={[
                          item.filterValue.startDate &&
                            new Date(item.filterValue.startDate),
                          item.filterValue.endDate &&
                            new Date(item.filterValue.endDate),
                        ]}
                      />
                      <div className="input-group-text bg-primary border-primary text-white calender-range-toggle-button">
                        {item.filterValue.startDate !== "" &&
                        item.filterValue.endDate !== "" ? (
                          <i
                            className="fa-solid fa-calendar-xmark"
                            onClick={() => {
                              setAllowedFilters((prevState) => {
                                const newState = [...prevState];
                                newState[index].filterValue.startDate = "";
                                newState[index].filterValue.endDate = "";
                                return newState;
                              });
                            }}
                          ></i>
                        ) : (
                          <i className="ri-calendar-2-line" onClick={openDateRangePicker} title="Open the calendar"></i>
                        )}
                      </div>
                    </div>
                  )}
                  {item.filterType === "DateRange2Values" && (
                    <div className="input-group input-group2">
                      <div></div>
                      <Flatpickr
                        className="form-control border-0 dash-filter-picker shadow"
                        options={{
                          mode: "range",
                          dateFormat: "d M Y",
                          altDateFormat: "Y-m-d",
                          defaultDate: [
                            item.filterValue.startDate &&
                              new Date(item.filterValue.startDate),
                            item.filterValue.endDate &&
                              new Date(item.filterValue.endDate),
                          ],
                        }}
                        onChange={(e) => {
                          let startDate = handleDateFormat(e[0]);
                          let endDate = handleDateFormat(e[1]);

                          setAllowedFilters((prevState) => {
                            const newState = [...prevState];
                            newState[index].filterValue.startDate = startDate;
                            newState[index].filterValue.endDate = endDate;
                            return newState;
                          });
                        }}
                        value={[
                          item.filterValue.startDate &&
                            new Date(item.filterValue.startDate),
                          item.filterValue.endDate &&
                            new Date(item.filterValue.endDate),
                        ]}
                      />
                      <div className="input-group-text bg-primary border-primary text-white calender-range-toggle-button">
                        {item.filterValue.startDate !== "" &&
                        item.filterValue.endDate !== "" ? (
                          <i
                            className="fa-solid fa-calendar-xmark"
                            onClick={() => {
                              setAllowedFilters((prevState) => {
                                const newState = [...prevState];
                                newState[index].filterValue.startDate = "";
                                newState[index].filterValue.endDate = "";
                                return newState;
                              });
                            }}
                          ></i>
                        ) : (
                          <i className="ri-calendar-2-line" onClick={openDateRangePicker} title="Open the calendar"></i>
                        )}
                      </div>
                    </div>
                  )}
                  {
                    // if filterType is Select
                    item.filterType === "Select" && (
                      <div>
                        <Select
                          isClearable={true}
                          className="mb-0 job-select2"
                          placeholder={`Select ${item.filterTitle}…`}
                          value={
                            item.filterValue.Id
                              ? {
                                  label: item.filterOptions.find(
                                    (option) =>
                                      option.value === item.filterValue.Id
                                  )?.label,
                                  value: item.filterValue.Id,
                                  id: item.filterValue.Id,
                                }
                              : null
                          }
                          onChange={(e) => {
                            if (!e) e = { value: "" };
                            setAllowedFilters((prevState) => {
                              const newState = [...prevState];
                              newState[index].filterValue.Id = e.value;
                              return newState;
                            });
                          }}
                          options={item.filterOptions}
                        ></Select>
                      </div>
                    )
                  }
                  {
                    // if filterType is SelectMultiple
                    item.filterType === "SelectMultiple" && (
                      <div>
                        {/*Able to select and deselect multiple options*/}
                        <Select
                          isClearable={true}
                          className="mb-0 job-select2"
                          placeholder={`Select ${item.filterTitle}…`}
                          value={item.filterValue.selectedItems?.map((item) => ({
                            label: item.label,
                            value: item.value,
                            id: item.value,
                          }))}
                          onChange={(e) => {
                            if (!e) e = { value: "" };
                            setAllowedFilters((prevState) => {
                              const newState = [...prevState];
                              newState[index].filterValue.selectedItems =
                                e?.map((item) => ({
                                  label: item.label,
                                  value: item.value,
                                  id: item.value,
                                }));
                              return newState;
                            });
                          }}
                          options={item.filterOptions}
                          isMulti={true}
                        ></Select>
                      </div>
                    )
                  }
                  {
                    // Change #100413 - an on/off filter. On keeps only rows the
                    // filter matches (see the Toggle branch in index.js). A new
                    // filterValue object is set, never mutated, so Clear can
                    // still reset to allowedFiltersInit.
                    item.filterType === "Toggle" && (
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id={`filter-toggle-${index}`}
                          checked={item.filterValue?.on === true}
                          onChange={(e) => {
                            const on = e.target.checked;
                            setAllowedFilters((prevState) => {
                              const newState = [...prevState];
                              newState[index] = {
                                ...newState[index],
                                filterValue: { on },
                              };
                              return newState;
                            });
                          }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`filter-toggle-${index}`}
                        >
                          {item.filterLabel || item.filterTitle}
                        </label>
                      </div>
                    )
                  }
                  {
                    //if filterType is NumberRange
                    item.filterType === "NumberRange" && (
                      <div className="input-group input-group2">
                        <div className={"d-flex flex-row"}>
                          <div>
                            <input
                              type="number"
                              className="form-control  border-0   shadow"
                              placeholder="Min"
                              value={item.filterValue.min}
                              onChange={(e) => {
                                setAllowedFilters((prevState) => {
                                  const newState = [...prevState];
                                  newState[index].filterValue.min =
                                    e.target.value;
                                  return newState;
                                });
                              }}
                            />
                          </div>
                          <div>
                            <input
                              type={"number"}
                              className="form-control border-0   shadow"
                              placeholder="Max"
                              value={item.filterValue.max}
                              onChange={(e) => {
                                setAllowedFilters((prevState) => {
                                  const newState = [...prevState];
                                  newState[index].filterValue.max =
                                    e.target.value;
                                  return newState;
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    )
                  }
                </div>
              ) : null
            )}
          </OffcanvasBody>
        </form>
        <div className="offcanvas-footer border-top p-3 text-center hstack gap-2">
          <button
            type="button"
            className="btn btn-light w-100"
            disabled={activeCount === 0}
            onClick={() => {
              setAllowedFilters(allowedFiltersInit);
            }}
          >
            Clear{activeCount > 0 ? ` (${activeCount})` : ""}
          </button>
          <button
            type="button"
            className="btn btn-primary w-100"
            onClick={() => setShowFilter(false)}
          >
            Done
          </button>
        </div>
      </Offcanvas>
    </>
  );
}
